<template>
  <nx-content-wizard
      ref="wizard"
      type="live"
      :active="active"
      @create="onCreate"
      @dismiss="onDismiss"
      @entityCreated="entityCreated"
  >
  </nx-content-wizard>
</template>

<script>
import Wizard from '@/modules/content/wizard/ContentWizard';

export default {
  name: 'nx-content-live-wizard',
  components: {
    [Wizard.name]: Wizard,
  },
  props: {
    active: Boolean,
  },
  methods: {
    onCreate() {
      this.$refs.wizard.submit();
    },
    onDismiss() {
      this.$emit('dismiss');
    },
    entityCreated(entity) {
      this.$emit('entityCreated', entity);
    },
  },
};
</script>
